import httpClient, { httpFormDataClient } from "./httpClient";

const prefix = "/incapacities";

export async function createIncapacity(partnerId, incapacityData, proofFiles) {
  const formData = new FormData();

  if (proofFiles && proofFiles.length > 0) {
    proofFiles.forEach((file) => {
      formData.append("proofFiles", file);
    });
  }

  Object.keys(incapacityData).forEach((key) => {
    formData.append(key, incapacityData[key]);
  });

  return (await httpFormDataClient.post(`${prefix}/${partnerId}`, formData))
    .data;
}

export async function deleteProofFile(id) {
  return (await httpClient.delete(`${prefix}/proof-files/${id}`)).data;
}

export async function updateIncapacity(id, updateData) {
  return (await httpClient.put(`${prefix}/${id}`, updateData)).data;
}

export async function uploadFilesToIncapacity(id, proofFiles) {
  const formData = new FormData();

  if (proofFiles && proofFiles.length > 0) {
    proofFiles.forEach((file) => {
      formData.append("proofFiles", file);
    });
  }

  return (await httpFormDataClient.post(`${prefix}/${id}/files`, formData))
    .data;
}

export async function approveIncapacity(id, approveData) {
  return (await httpClient.patch(`${prefix}/${id}/approve`, approveData)).data;
}

export async function getIncapacitiesByPartner(partnerId) {
  return (await httpClient.get(`${prefix}/partner/${partnerId}`)).data;
}

export async function getIncapacityById(id) {
  return (await httpClient.get(`${prefix}/${id}`)).data;
}

export async function getAllIncapacities(params = {}) {
  const queryParams = new URLSearchParams();
  
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.offset) queryParams.append('offset', params.offset);
  if (params.param) queryParams.append('param', params.param);
  if (params.sort) queryParams.append('sort', params.sort);
  if (params.order) queryParams.append('order', params.order);
  if (params.status) queryParams.append('status', params.status);
  if (params.incapacityDate) queryParams.append('incapacityDate', params.incapacityDate);
  
  if (params.bossId) {
    const response = await httpClient.get(`${prefix}/by-direct-boss/${params.bossId}`);
    return {
      data: response.data,
      total: response.data?.length || 0
    };
  }

  const url = queryParams.toString() ? `${prefix}?${queryParams.toString()}` : prefix;
  const response = await httpClient.get(url);
  
  // El backend devuelve directamente el array, no un objeto con data y total
  // Simulamos la estructura esperada por el frontend
  return {
    data: response.data,
    total: response.data?.length || 0
  };
}

export async function exportIncapacitiesExcel(year?: number) {
  const params = new URLSearchParams();
  if (year) params.append('year', String(year));
  const url = params.toString() ? `${prefix}/export/excel?${params.toString()}` : `${prefix}/export/excel`;
  const response = await httpClient.get(url, { responseType: 'blob' });
  return response;
}

export async function importIncapacitiesExcel(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  
  return (await httpFormDataClient.post(`${prefix}/import/excel`, formData)).data;
}

export async function getActiveIncapacityByPartner(partnerId: number, date: string) {
  try {
    const incapacities = await getIncapacitiesByPartner(partnerId);
    const formattedDate = new Date(date);
    
    const activeIncapacity = incapacities.find(incapacity => {
      if (!incapacity.approved || incapacity.isRejected) return false;
      
      const startDate = new Date(incapacity.startDate * 1000);
      const endDate = new Date(incapacity.endDate * 1000);
      
      return formattedDate >= startDate && formattedDate <= endDate;
    });
    
    return activeIncapacity || null;
  } catch (error) {
    console.error('Error verificando incapacidades activas:', error);
    return null;
  }
}
